<template>
  <div class="user-management">
    <template>
      <h4 style="color: aliceblue;margin-top: -30px">
        车辆申报审批
      </h4>
    </template>
    <el-row :gutter="40">
      <el-col :span="24" :xs="24">
        <el-form ref="queryForm" :inline="true" :model="queryParams" label-width="68px" size="small">
          <el-form-item  prop="coId">
            <el-select v-model="queryParams.coId" filterable placeholder="所属企业">
              <el-option label="全部" value="" />
              <el-option v-for="item in company2" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="queryParams.plateNo" placeholder="车牌号、姓名、手机号" clearable/>
          </el-form-item>
          <el-form-item prop="declareType">
            <el-select v-model="queryParams.declareType" placeholder="申报类型" style="width: 100px;">
              <el-option label="全部" value="" />
              <el-option v-for="item in declaretype" :key="item.code" :label="item.name" :value="parseInt(item.code)">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="declareType">
            <el-select v-model="queryParams.checkStatus" placeholder="审批状态" style="width: 100px;">
              <el-option v-for="item in option2" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="vehicleType">
           <el-select v-model="queryParams.vehicleType" placeholder="车辆类型" style="width: 100px;">
             <el-option label="全部" value="" />
             <el-option v-for="item in vehicletype" :key="item.value" :label="item.name" :value="parseInt(item.code)">
             </el-option>
           </el-select>
          </el-form-item>
          <el-form-item prop="isDelete">
           <el-select v-model="queryParams.isDelete" placeholder="是否有效" style="width: 100px;">
             <el-option label="全部" value="" />
             <el-option label="有效" value="0" />
             <el-option label="无效" value="1" />
           </el-select>
          </el-form-item>
          <!-- <el-form-item>
            <el-date-picker v-model="queryParams.Time" prefix-icon="el-icon-date" type="datetimerange"
              start-placeholder="申报开始日期" end-placeholder="申报结束日期" size="small" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item> -->
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="handleQuery">搜索</el-button>
            
            <el-select v-model="queryParams.moreType" @change="delIds" placeholder="批量类型" style="width: 100px;">
              <el-option label="批量审批" value="1" />
              <el-option label="批量延期" value="2" />
            </el-select>
            
            <el-button
              :disabled="multiple"
              type="primary"
              style="margin-left:15px"
              v-if="queryParams.moreType == 1"
              @click="moreCheck"
              >批量审批
            </el-button>
            <el-button
              :disabled="multiple"
              type="primary"
              style="margin-left:15px"
              v-if="queryParams.moreType == 2"
              @click="moreDelay"
              >批量延期
            </el-button>
            <el-button icon="el-icon-download" type="primary" @click="exportData" v-if="!exportTip">导出Excel</el-button>
          </el-form-item>
          
        </el-form>

        <el-table v-loading="loading" element-loading-text="数据载入中" element-loading-spinner="el-icon-loading"
          :data="pageList" @selection-change="handleSelectionChange" :show-overflow-tooltip="true" ref="multipleTable">
          <el-table-column align="center" type="selection" width="50" :selectable="checkSelectable"/>
          <el-table-column align="center" label="所属企业" prop="coName" show-overflow-tooltip />
          <el-table-column align="center" label="司机姓名" prop="name" width="80" />
          <el-table-column align="center" label="司机手机号" prop="mobile" width="80" show-overflow-tooltip/>
          <!-- <el-table-column align="center" label="司机身份证" prop="idCard" width="116" show-overflow-tooltip>
          </el-table-column> -->
          <el-table-column align="center" label="车牌号码" prop="plateNo" width="90" >
            <template slot-scope="scope">
              <span v-if="scope.row.blackType == 2" style="color: red;"><b>{{scope.row.plateNo}}</b></span>
              <span v-else>{{scope.row.plateNo}}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="车牌颜色" prop="plateColor" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.plateColor == 1">黑色</span>
              <span v-if="scope.row.plateColor == 2">白色</span>
              <span v-if="scope.row.plateColor == 5">蓝色</span>
              <span v-if="scope.row.plateColor == 6">黄色</span>
              <span v-if="scope.row.plateColor == 9">绿色</span>
              <span v-if="scope.row.plateColor == 99">未知</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="有效期始" prop="validityPeriodStart" width="92" />
          <el-table-column align="center" label="有效期止" prop="validityPeriodEnd" width="92" />
          <el-table-column align="center" label="申报类型" prop="declareType" width="92">
            <template slot-scope="scope">
              <span v-if="scope.row.declareType == 1">企业申报</span>
              <span v-if="scope.row.declareType == 2">临时申报</span>
              <span v-if="scope.row.declareType == 3">通勤申报</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="车辆类型" prop="vehicleType" width="96">
            <template slot-scope="scope">
              <span v-if="scope.row.vehicleType == 1">轿车</span>
              <span v-if="scope.row.vehicleType == 2">客车</span>
              <span v-if="scope.row.vehicleType == 3">货车</span>
              <span v-if="scope.row.vehicleType == 4">危化品车</span>
              <span v-if="scope.row.vehicleType == 6">营运车</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="申报时间" prop="createTime" width="100" />
          <el-table-column align="center" label="审批时间" prop="checkTime" width="100" />
          <el-table-column align="center" label="审批状态" prop="checkStatus" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.checkStatus == 0"><b>未审批</b></span>
              <span v-if="scope.row.checkStatus == 1" style="color: green;"><b>审批通过</b></span>
              <span v-if="scope.row.checkStatus == 2" style="color: red;"><b>审批未通过</b></span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="是否有效" prop="isDelete" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.isDelete == 0 && scope.row.checkStatus == 1" style="color: green;"><b>有效</b></span>
              <span v-if="scope.row.isDelete == 1 && scope.row.checkStatus == 1" style="color: red;"><b>无效</b></span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="事由" prop="reason" width="100" show-overflow-tooltip v-if="queryParams.declareType == 2 ||queryParams.declareType == ''"/>
          <el-table-column align="center" label="备注" prop="remark" width="100" show-overflow-tooltip v-if="queryParams.declareType != 2 ||queryParams.declareType == ''"/>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button v-if="computeValidityPeriod(scope.row.validityPeriodEnd) <= 7 && scope.row.declareType == 1 && scope.row.checkStatus == 1" type="primary" size="mini" circle plain
                @click.stop="handleDelay(scope.row)">延期</el-button>
              <el-button v-if="scope.row.checkStatus == 0" type="success" size="mini" circle plain
                @click.stop="handleApproval(scope.row)">审批</el-button>
              <el-button type="info" size="mini" circle plain @click.stop="handleDetail(scope.row)">详情</el-button>
              <el-button type="danger" icon="el-icon-delete" size="mini" circle plain
                @click.stop="handleDelete(scope.row)" />
            </template>
          </el-table-column>
        </el-table>

        <commonPagination :page="pagination" :pageSizes="[10, 20]" :getList="handleQuery">
        </commonPagination>
      </el-col>
    </el-row>


    <el-dialog title="审批详情" :visible.sync="dialogVisible" width="50%" custom-class="zlkgl"
      :close-on-click-modal="false">
      <el-form :model="form" ref="form1" :rules="rules">
        <el-form-item label="审批状态" prop="checkStatus">
          <el-radio-group v-model="form.checkStatus">
            <el-radio :label="item.value" :key="item.value" v-for="item in isCheckStatus">{{item.label}}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="意见内容" prop="checkOpinion">
          <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.checkOpinion">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogSubmit(1)" :loading="loadingbut" v-if="!buttonVisible">{{buttontext}}</el-button>
        <el-button type="primary" @click="dialogSubmit(2)" :loading="loadingbut" v-if="buttonVisible">{{buttontext}}</el-button>
      </span>
    </el-dialog>


    <el-dialog title="有效期延期" :visible.sync="delayVisible" width="50%" custom-class="zlkgl"
      :close-on-click-modal="false">
      <el-form  :model="dataForm3"  :rules="rules">
        <el-row>
          <el-col :span="12">
          <el-form-item label="延长有效期" >
              <el-select v-model="dataForm3.type" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
          </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delaySubmit(1)" :loading="loadingbut" v-if="!buttonVisible">{{buttontext}}</el-button>
        <el-button type="primary" @click="delaySubmit(2)" :loading="loadingbut" v-if="buttonVisible">{{buttontext}}</el-button>
      </span>
    </el-dialog>

    <el-dialog title="根据时间查询导出Excel数据" :visible.sync="excelVisible" width="40%"  :close-on-click-modal="false">
      <el-form :model="queryExcel" >
        <el-form-item>
            <el-date-picker v-model="queryExcel.Time" prefix-icon="el-icon-date" type="datetimerange"
              start-placeholder="申报开始日期" end-placeholder="申报结束日期" size="small" value-format="yyyy-MM-dd HH:mm:ss"  style="width: 330px;">
            </el-date-picker>
            <el-button icon="el-icon-search" type="primary" @click="exportQuery" size="small" :loading="excelLoad">查询</el-button>
        </el-form-item>
        <el-form-item>
         <h3 style="color:white"> 查询条数:{{jsonNum}}</h3>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-download" type="primary" @click="exportExcel" v-if="!exportTip" size="small">导出Excel</el-button>
        </el-form-item>
        <el-form-item v-if="exportTip">
            <download-excel
              :data="jsonData"
              :fields="json_fields"
              type="xls"
              worksheet="车辆申报审批数据"
              :name="tableName"
            >
              <el-button ref="exportData" icon="el-icon-download" size="small">导出中...</el-button>
            </download-excel>
        </el-form-item>
        <h4 style="color:white"> 注:查询条数不超过1000条时才可导出Excel表数据!</h4>
      </el-form>
    </el-dialog>

    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" width="800px">
      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="企业名称" prop="coId" v-if="form.vehicleType != 6">
              <el-select v-model="form.coId" placeholder="" disabled>
                <el-option v-for="item in company" :key="item.value" :label="item.lable" :value="parseInt(item.value)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机姓名" prop="name">
              <el-input v-model="form.name" placeholder="" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机手机号" prop="mobile">
              <el-input v-model="form.mobile" placeholder="" type="number" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="司机身份证" prop="idCard">
              <el-input v-model="form.idCard" placeholder="" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌号码" prop="plateNo">
              <el-input v-model="form.plateNo" placeholder="" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车牌颜色" prop="plateColor">
              <el-select v-model="form.plateColor" placeholder="" disabled>
                <el-option v-for="item in platecolor" :key="item.value" :label="item.name" :value="parseInt(item.code)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期始" prop="validityPeriodStart">
              <el-date-picker v-model="form.validityPeriodStart"  value-format="yyyy-MM-dd"
                type="date" disabled></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期止" prop="validityPeriodEnd">
              <el-date-picker v-model="form.validityPeriodEnd"  value-format="yyyy-MM-dd"
                type="date" disabled></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.declareType != 2 && form.vehicleType != 4">
            <el-form-item label="每日访问时段" prop="passTime">
              <el-input v-model="form.passTime" placeholder="无" type="textarea" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.declareType == 2 && form.vehicleType != 4">
            <el-form-item label="随行人员(含驾驶员)" prop="entourage">
              <el-input v-model="form.entourage" placeholder="" type="number" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 3">
            <el-form-item label="货车载重(kg)" prop="carryingCapasity">
              <el-input v-model="form.carryingCapasity" placeholder="" type="number" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 2">
            <el-form-item label="客运公司" prop="carrier">
              <el-input v-model="form.carrier" placeholder="" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 4">
            <el-form-item label="货物类型">
              <el-select v-model="form.goodsType" placeholder="" prop="goodsType" disabled>
                <el-option v-for="item in goodstype" :key="item.value" :label="item.name" :value="parseInt(item.code)" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 4">
            <el-form-item label="货物名称" prop="goodsName">
              <el-input v-model="form.goodsName" placeholder="" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 4">
            <el-form-item label="押运人姓名" prop="supercargoName">
              <el-input v-model="form.supercargoName" placeholder="" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 4">
            <el-form-item label="押运人机号" prop="supercargoMobile">
              <el-input v-model="form.supercargoMobile" placeholder="" type="number" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 4">
            <el-form-item label="押运人身份证" prop="supercargoIdcard">
              <el-input v-model="form.supercargoIdcard" placeholder="" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 4 || form.vehicleType == 3">
            <el-form-item label="承运公司" prop="carrier">
              <el-input v-model="form.carrier" placeholder="" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="!(form.declareType != 2 && form.vehicleType == 1)">
            <el-form-item label="事由" prop="reason">
              <el-input v-model="form.reason" placeholder="" type="textarea" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.declareType != 2 && form.vehicleType == 1">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="form.remark" placeholder="" type="textarea" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="审批意见">
              <el-input v-model="form.checkOpinion" placeholder="" type="textarea" disabled/>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.vehicleType == 3 || form.vehicleType == 4">
            <el-form-item label="驾驶证" prop="drivingLicense">
              <img :src="form.drivingLicense" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.drivingLicense)">
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="form.vehicleType == 3 || form.vehicleType == 4">
            <el-form-item label="行驶证" prop="vehicleLicense">
              <img :src="form.vehicleLicense" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.vehicleLicense)">
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="form.vehicleType == 4">
            <el-form-item label="押运证" prop="escortLicense">
              <img :src="form.escortLicense" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.escortLicense)">
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="form.vehicleType == 4">
            <el-form-item label="电子运单" prop="wayBill">
              <img :src="form.wayBill" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.wayBill)">
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="港区证明文件" v-if="form.declareType == 1 && form.vehicleType != 4">
              <img :src="form.proveFile" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.proveFile)">
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="行程单" v-if="form.vehicleType == 6">
              <img :src="form.journeyImg" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.journeyImg)">
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="健康码" v-if="form.declareType == 2 || form.vehicleType == 4">
              <img :src="form.ykCode" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.ykCode)">
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="行程码" v-if="form.declareType == 2 || form.vehicleType == 4">
              <img :src="form.xcCode" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.xcCode)">
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="核酸报告" v-if="form.declareType == 2 || form.vehicleType == 4">
              <img :src="form.yyCode" width="100%" alt="" height="180px" @click="handlePictureCardPreview(form.yyCode)">
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-image-viewer
      v-if="!!bigImgSrc"
      :on-close="closeImgViewer"
      :url-list="[bigImgSrc]"
    />
  </div>
</template>

<script>
  import commonPagination from "@/components/commonPagination.vue";
  import ElImageViewer from "@/components/CustomImageViewer";
  export default {
    name: "Car-management",
    components: {
      commonPagination,ElImageViewer
    },
    props: {},
    data() {
      const typeTime = {
        beginTime: this.$myPlug.timeFormat(
          new Date().getTime(),
          "yyyy-mm-dd 00:00:00"
        ),
        endTime: this.$myPlug.timeFormat(new Date().getTime(), "yyyy-mm-dd 23:59:59"),
      };
      return {
        declaretype: JSON.parse(sessionStorage.getItem('dictionary')).DECLARETYPE,
        checkstatus: JSON.parse(sessionStorage.getItem('dictionary')).CHECKSTATUS,
        platecolor:JSON.parse(sessionStorage.getItem('dictionary')).PLATECOLOR,
        goodstype:JSON.parse(sessionStorage.getItem('dictionary')).GOODSTYPE,
        vehicletype:JSON.parse(sessionStorage.getItem('dictionary')).VEHICLETYPE,
        company:JSON.parse(localStorage.getItem('company')),
        company2:[],
        option2: [{
          value: "",
          label: '全部'
        }, {
          value: 0,
          label: '未审批'
        }, {
          value: 1,
          label: '审批通过'
        }, {
          value: 2,
          label: '审批未通过'
        }, {
          value: 3,
          label: '已审批'
        }],
        options: [{
          value: 1,
          label: '一月'
        }, {
          value: 2,
          label: '半年'
        }, {
          value: 3,
          label: '一年'
        }, {
          value: 4,
          label: '三年'
        }],
        bigImgSrc: "",
        dialogVisible: false,
        delayVisible: false,
        loadingbut:false,
        buttontext:"提 交",
        buttonVisible:false,
        // 审批表单
        dataForm2: {
          id: 0,
          ids:[],
          checkStatus: null,
          checkOpinion: null
        },
        // 延期表单
        dataForm3: {
          id: 0,
          ids:[],
          type: 1
        },
        isCheckStatus: [{
            label: "审批通过",
            value: 1
          },
          {
            label: "审批未通过",
            value: 2
          }
        ],
        excelVisible:false,
        tableName: "",
        exportTip:false,
        json_fields: {
                所属企业: "coName",
                司机姓名: "name",
                司机手机号: "mobile",
                司机身份证: {
                  field: "idCard",
                    callback: value => {
                      return `'${value.toString()}'`;
                    }
                },
                车牌号码: "plateNo",
                车牌颜色: {
                  field: "plateColor",
                    callback: value => {
                      if(value == 1){
                        value = "黑色";
                      }else if(value == 2){
                        value = "白色";
                      }else if(value == 5){
                        value = "蓝色";
                      }else if(value == 6){
                        value = "黄色";
                      }else if(value == 9){
                        value = "绿色";
                      }else if(value == 99){
                        value = "未知";
                      }
                      return value;
                    }
                },
                有效期始: "validityPeriodStart",
                有效期止: "validityPeriodEnd",
                申报类型: {
                  field: "declareType",
                    callback: value => {
                      if(value == 1){
                        value = "企业申报";
                      }else if(value == 2){
                        value = "临时申报";
                      }else if(value == 3){
                        value = "通勤申报";
                      }
                      return value;
                    }
                },
                车辆类型: {
                  field: "vehicleType",
                    callback: value => {
                      if(value == 1){
                        value = "轿车";
                      }else if(value == 2){
                        value = "客车";
                      }else if(value == 3){
                        value = "货车";
                      }else if(value == 4){
                        value = "危化品车";
                      }else if(value == 6){
                        value = "营运车";
                      }
                      return value;
                    }
                },
                申报时间: "createTime",
                审批时间: "checkTime",
                审批状态: {
                  field: "checkStatus",
                    callback: value => {
                      if(value == 0){
                        value = "未审批";
                      }else if(value == 1){
                        value = "审批通过";
                      }else if(value == 2){
                        value = "审批未通过";
                      }
                      return value;
                    }
                },
                是否有效: {
                  field: "isDelete",
                    callback: value => {
                      if(value == 0){
                        value = "有效";
                      }else if(value == 1){
                        value = "无效";
                      }
                      return value;
                    }
                },
                事由: "reason",
                备注: "remark"
              },
        jsonData:[],
        jsonNum:0,
        loading: true,
        excelLoad:false,
        // 选中数组
        ids: [],
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        queryParam: {
          pageIndex: 0,
          pageRow: 300,
        },
        queryParams: {
          declareType: undefined,
          checkStatus: undefined,
          vehicleType: undefined,
          isDelete: "0",
          moreType: "1",
          Time: Object.values(typeTime)
        },
        queryExcel: {
          coId: undefined,
          plateNo: undefined,
          declareType: undefined,
          checkStatus: undefined,
          vehicleType: undefined,
          isDelete: "0",
          pageIndex: 1,
          pageRow: 1000,
          Time: Object.values(typeTime)
        },
        pagination: {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        },
        pageList: [],
        dialog: {
          title: undefined,
          visible: false,
          flag: true
        },
        apiUrl: {
          approvalApi: 'POST_hyCarDeclareVerify',
          indexApi: 'POST_hyCarDeclareWebCheck',
          delApi: 'GET_hyCarDeclareDelete',
          detailApi: 'GET_hyCarDeclareFind',
          Enterpriseinfo: 'POST_hyEnterpriseByRole'
        },
        // 表单参数
        form: {
          id: "",
          carrier: "",
          carryingCapasity: 0,
          coId: "",
          declareType: 1,
          drivingLicense: "",
          entourage: 0,
          escortLicense: "",
          goodsName: "",
          goodsType: 0,
          idCard: "",
          mobile: "",
          name: "",
          passTime: "",
          plateColor: "",
          plateNo: "",
          reason: "",
          remark: "",
          supercargoIdcard: "",
          supercargoMobile: "",
          supercargoName: "",
          validityPeriodEnd: "",
          validityPeriodStart: "",
          vehicleLicense: "",
          vehicleType: 1,
          wayBill: "",
          checkStatus: 0,
          checkOpinion: ""
        },
        // 表单校验
        rules: {
            checkStatus: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }],
            checkOpinion: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
        }
      };
    },
    methods: {
      buildQueryParams(source) {
        const params = { ...source };
        Object.keys(params).forEach(key => {
          if (params[key] === "") {
            delete params[key];
          }
        });
        return params;
      },
      async loadData() {
        let declareType = this.$route.params.declareType;
        let checkStatus = this.$route.params.checkStatus;
        let vehicleType = this.$route.params.vehicleType;
        if (checkStatus != null) {
          this.queryParams.declareType = declareType;
          this.queryParams.checkStatus = checkStatus;
          this.queryParams.vehicleType = vehicleType;
        }
        this.handleQuery();
      },
      handleQuery(obj = {}) {
        if ("pageNo" in obj) {
          this.queryParams.pageIndex = this.pagination.pageIndex = obj.pageNo;
        } else {
          this.queryParams.pageIndex = 1;
        }
        if ("pageSize" in obj) {
          this.queryParams.pageRow = this.pagination.pageRow = obj.pageSize;
        } else {
          this.queryParams.pageRow = this.pagination.pageRow;
        }
          this.$http[this.apiUrl.indexApi](this.buildQueryParams(this.queryParams)).then(response => {
            const {
              data,
              total
            } = response;
            if (response.code == '00000') {
                 this.pageList = data;
                 this.pagination.total = total;
                 this.loading = false;
            } else {
              this.$message.error(response.msg);
              this.pageList = data;
              this.pagination.total = total;
              this.loading = false;
            }
          });
      },
      exportQuery(){
        this.excelLoad = true;
        this.queryExcel.beginTime = "";
        this.queryExcel.endTime = "";
        this.queryExcel.coId = this.queryParams.coId;
        this.queryExcel.plateNo = this.queryParams.plateNo;
        this.queryExcel.declareType = this.queryParams.declareType;
        this.queryExcel.checkStatus = this.queryParams.checkStatus;
        this.queryExcel.vehicleType = this.queryParams.vehicleType;
        this.queryExcel.isDelete = this.queryParams.isDelete;
        if(this.queryExcel.Time != null){
          this.queryExcel.beginTime = this.queryExcel.Time[0];
          this.queryExcel.endTime = this.queryExcel.Time[1];
          this.$http[this.apiUrl.indexApi](this.buildQueryParams(this.queryExcel)).then(response => {
            const {
              data,
              total
            } = response;
            if (response.code == '00000') {
                 this.jsonData = data;
                 this.jsonNum = total;
                 this.loading = false;
                 this.excelLoad = false;
                 if(total <= 1000){
                    this.tableName = "车辆申报审批数据"+this.$myPlug.timeFormat(new Date().getTime(), "yyyy-mm-dd hh:MM:ss");
                  }
            } else {
              this.$message.error(response.msg);
              this.loading = false;
              this.excelLoad = false;
            }
          });
        }else{
          this.$message.error("申报时间查询不能为空!");
        }
      },
      exportExcel(){
          this.exportTip = true;
          setTimeout(() => {
            if(this.jsonNum >1000){
              this.$message.error("导出数据超过1000条,请重新进行条件筛选!");
              this.exportTip = false;
            }
            else if(this.jsonNum <=1000 && this.jsonNum >0){
              this.$refs.exportData.$el.click();
              this.exportTip = false;
              this.excelVisible = false;
            }else{
              this.exportTip = false;
              this.$message.error("导出数据为空,请重新进行条件筛选!");
            }
          }, 500);
      },
      exportData(){
        this.excelVisible = true;
        this.exportQuery();
      },

      handleReset() {
        this.pagination = {
          pageIndex: 1,
          pageRow: 10,
          total: 0
        };
        this.queryParams = {

        };
        this.handleQuery();
      },

      async handleApproval(res) {
        this.dialogVisible = true;
        this.buttonVisible = false;
        const data = JSON.parse(JSON.stringify(res));
        this.form = data;
        this.loadingbut = false;
        this.buttontext = "提 交";
      },
      handleDelay(res){ 
        this.delayVisible = true;
        this.buttonVisible = false;
        const data = JSON.parse(JSON.stringify(res));
        this.form = data;
        this.loadingbut = false;
        this.buttontext = "提 交";
      },
      moreCheck() {
        this.form.checkOpinion = "";
        this.form.checkStatus = 0;
        this.buttonVisible = true;
        this.dialogVisible = true;
        this.loadingbut = false;
        this.buttontext = "提 交";
      },
      moreDelay() {
        this.buttonVisible = true;
        this.delayVisible = true;
        this.loadingbut = false;
        this.buttontext = "提 交";
      },
      dialogSubmit(type) {
        this.$refs["form1"].validate(valid => {
          if (valid) {
            if(this.form.checkStatus == 0){
              this.$message.error("请选择审批状态！");
            }else{
                if(type == 1){
                  this.loadingbut = true;
                  this.buttontext = "提交中..."
                  this.dataForm2.id = this.form.id
                  this.dataForm2.checkOpinion = this.form.checkOpinion
                  this.dataForm2.checkStatus = this.form.checkStatus
                  this.$http.POST_hyCarDeclareVerify(this.dataForm2).then(res => {
                    if (res.code == '00000') {
                      this.$message.success("审批成功");
                      this.handleQuery();
                      this.dialogVisible = false;
                      this.loadingbut = false;
                      this.buttontext = "提 交";
                    } else {
                      let msg = res.msg;
                      if(msg.indexOf("405 Not Allowed") != -1){
                        this.$message.error("短时间请求次数过多,请30分钟后再次请求!");
                      }else{
                        this.$message.error("审批失败" + res.msg);
                      }
                      this.loadingbut = false;
                      this.buttontext = "提 交";
                    }
                  })
                }else{
                  this.loadingbut = true;
                  this.buttontext = "批量提交中..."
                  this.dataForm2.ids = this.ids
                  this.dataForm2.checkOpinion = this.form.checkOpinion
                  this.dataForm2.checkStatus = this.form.checkStatus
                  console.log(this.dataForm2)
                  this.$http.POST_hyCarDeclareBatchCheck(this.dataForm2).then(res => {
                    if (res.code == '00000') {
                      this.$message.success("审批成功");
                      this.handleQuery();
                      this.dialogVisible = false;
                      this.loadingbut = false;
                      this.buttontext = "提 交";
                    } else {
                      let msg = res.msg;
                      if(msg.indexOf("405 Not Allowed") != -1){
                        this.$message.error("短时间请求次数过多,请30分钟后再次请求!");
                      }else{
                        this.$message.error("审批失败" + res.msg);
                      }
                      this.handleQuery();
                      this.loadingbut = false;
                      this.buttontext = "提 交";
                    }
                  })
                }
              }
          }
        });
      },
      delaySubmit(type) {
        if(type == 1){
          this.loadingbut = true;
          this.buttontext = "提交中..."
          this.dataForm3.id = this.form.id
          console.log(this.dataForm3)
          this.$http.POST_delay(this.dataForm3).then(res => {
            if (res.code == '00000') {
              this.$message.success("延期成功");
              this.handleQuery();
              this.delayVisible = false;
              this.loadingbut = false;
              this.buttontext = "提 交";
            } else {
              let msg = res.msg;
              if(msg.indexOf("405 Not Allowed") != -1){
                this.$message.error("短时间请求次数过多,请30分钟后再次请求!");
              }else{
                this.$message.error("延期失败" + res.msg);
              }
              this.loadingbut = false;
              this.buttontext = "提 交";
            }
          })
        }else{
          this.loadingbut = true;
          this.buttontext = "批量提交中..."
          this.dataForm3.ids = this.ids
          console.log(this.dataForm3)
          this.$http.POST_batchDelay(this.dataForm3).then(res => {
            if (res.code == '00000') {
              this.$message.success("延期成功");
              this.handleQuery();
              this.delayVisible = false;
              this.loadingbut = false;
              this.buttontext = "提 交";
            } else {
              let msg = res.msg;
              if(msg.indexOf("405 Not Allowed") != -1){
                this.$message.error("短时间请求次数过多,请30分钟后再次请求!");
              }else{
                this.$message.error("延期失败" + res.msg);
              }
              this.handleQuery();
              this.loadingbut = false;
              this.buttontext = "提 交";
            }
          })
        }
      },
      delIds(){
        this.ids = []
        this.$refs.multipleTable.clearSelection();
      },
      async handleDetail(row) {
        this.resetForm();
        this.dialog = {
          title: "申报详情",
          visible: true,
          flag: false
        };
        const id = row.id || this.ids;
        this.$http[this.apiUrl.detailApi]({
          paramsID: id
        }).then(response => {
          if (response.code == '00000') {
            this.form = response.data;
            this.form.plateColor = parseInt(response.data.plateColor);
          } else {
            if (response.msg == null)
              this.$message.error("获取数据失败！");
            else {
              this.$message.error(response.msg);
            }
          }
        });
      },
      handleDelete(row) {
        const id = row.id;
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http[this.apiUrl.delApi]({
            paramsID: id
          }).then(response => {
            if(response.code == '00000'){
              this.$message.success("删除成功");
              this.handleQuery();
            }else{
              this.$message.error(response.msg);
            }
          });
        }).catch(() => {});
      },
      handlePictureCardPreview(file) {
        this.bigImgSrc = file;
      },
      closeImgViewer(){
        this.bigImgSrc = false;
      },
      getCompany(){
        this.$http[this.apiUrl.Enterpriseinfo](this.queryParam).then(res => {
          if(res.data.length>1){
            res.data.forEach((element, key) => {
              this.company2.push({
                lable: element.coName,
                value: element.id,
              });
            });
          }else{
            this.company2.push({
              lable: res.data.coName,
              value: res.data.id,
            });
          }
        });
      },
      // 多选框选中数据
      handleSelectionChange(selection) {
          this.ids = [];
          selection.forEach(s => {
                if(s.checkStatus == 0 && this.queryParams.moreType == 1){
                  this.ids.push(s.id)
                }
                if(s.checkStatus == 1 && this.queryParams.moreType == 2){
                  this.ids.push(s.id)
                }
            })
          //this.ids = selection.map(item => (item.id));
          this.single = selection.length !== 1;
          this.multiple = !selection.length;
      },
      
      checkSelectable(row,index){
         let flag = true;
         if(this.queryParams.moreType == 1){
            //已审批不可选中
            if(row.checkStatus != 0){
              flag = false
            }
         }else{
            //审批通过近7天过期的企业车才可选中
            let days = this.computeValidityPeriod(row.validityPeriodEnd)
            if(row.checkStatus == 1 && row.declareType == 1 && days <= 7){
              flag = true
            }else{
              flag = false
            }
         }
         return flag
       },
      // 表单重置
      resetForm() {
        this.form = {
          id: "",
          carrier: "",
          carryingCapasity: 0,
          coId: "",
          declareType: 1,
          drivingLicense: "",
          entourage: 0,
          escortLicense: "",
          goodsName: "",
          goodsType: 0,
          idCard: "",
          mobile: "",
          name: "",
          passTime: "",
          plateColor: "",
          plateNo: "",
          reason: "",
          remark: "",
          supercargoIdcard: "",
          supercargoMobile: "",
          supercargoName: "",
          validityPeriodEnd: "",
          validityPeriodStart: "",
          vehicleLicense: "",
          vehicleType: 1,
          wayBill: "",
          checkStatus: 0,
          checkOpinion: ""
        };
        if (this.$refs["form"]) {
          this.$nextTick(() => {
          this.$refs["form"].resetFields();
          })
        }
      },
      computeValidityPeriod(validityPeriodEnd) {
      const currtime = new Date();
      const endDate = new Date(validityPeriodEnd);
      const diffInDays = Math.ceil((endDate - currtime) / (1000 * 60 * 60 * 24));
      return diffInDays;
      }
    },
    created() {
      this.loadData();
      this.getCompany();
    },
    watch: {

    }
  };
</script>

<style >
.el-textarea.is-disabled .el-textarea__inner {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: black;
    cursor: not-allowed;
}

</style>



// WEBPACK FOOTER //
// src/views/sbgl/sbclsp.vue